import {  Component, EventEmitter, Injector, Input, Output, inject } from '@angular/core';
import { SettingsService } from '@delon/theme';
import { DateFormatService } from 'src/app/shared/services/date-format.service';
import { MomentService } from 'src/app/shared/services/moment.service';
@Component({
  selector: 'app-einv-inquiry-date-range',
  templateUrl: './einv-inquiry-date-range.component.html',
  styles: [],
  standalone: false
})
export class EInvInquiryDateRangeComponent {
  private momentService = inject(MomentService);
  private _from: any;
  
  get country() {
    return this.settings.user['company'].country;
  }

  dateFormat() {
    return this.dateFormatService.currentDateFormatValue;
  };

  @Input() disableEinvDate: any;
  @Input() isRequired: boolean = false;
  @Input() allowClear: boolean = true;

  @Input() get from() {
    return this._from;
  }
  set from(value) {
    this._from = value;
    if (this._from && this._to) {
      this._dates = [this._from, this._to];
    }
  }
  private _to: any;
  @Input() get to() {
    return this._to;
  }
  set to(value) {
    this._to = value;
    if (this._from && this._to) {
      this._dates = [this._from, this._to];
    }
  }

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  private _dates: any[] = [];
  get dates() {
    return this._dates;
  }
  set dates(value: any[]) {
    if (value?.length) {
      this._from = value[0];
      this._to = value[1];
    } else {
      this._from = null;
      this._to = null;
      this._dates = [];
    }
    
    this.fromChange.emit(this.from);
    this.toChange.emit(this.to);
  }
  constructor(private settings: SettingsService,
    private dateFormatService: DateFormatService
  ) {}
}
